import { type BreadcrumbItem } from '@config'
import { PageLayoutTypeContext } from '@contexts/page-layout-type'
import FootnoteList from '@layouts/footnote-list'
import { GoUpButton } from '@ui/go-up-button'
import { Slice } from 'gatsby'
import React, { type FC, type PropsWithChildren } from 'react'

import { Navbar } from './navbar/navbar'

type Props = {
  breadcrumbs?: BreadcrumbItem[]
  titleComponent?: 'h1' | 'p'
  cta?: Queries.EntryFragment
}

export const FaqPageTemplate: FC<PropsWithChildren<Props>> = ({
  children,
  breadcrumbs = [],
  titleComponent = 'p',
  cta,
}) => {
  const PageLayoutTypeContextValue = {
    isLandingPage: false,
    isFaqPage: true,
  }

  return (
    <PageLayoutTypeContext.Provider value={PageLayoutTypeContextValue}>
      <GoUpButton />
      <Navbar cta={cta} />
      <Slice
        alias="faq-template"
        breadcrumbs={breadcrumbs}
        titleComponent={titleComponent}
      >
        {children}
      </Slice>
      <FootnoteList />
      <Slice alias="footer" />
    </PageLayoutTypeContext.Provider>
  )
}
